import { z } from "zod";

export const notificationSettings = z.object({
  transactionEmail: z.boolean(),
  productEmail: z.boolean(),
  marketingEmail: z.boolean(),
  transactionSms: z.boolean(),
  productSms: z.boolean(),
  groupChat: z.boolean(),
});
export type NotificationSettings = z.infer<typeof notificationSettings>;

export const NOTIFICATION_SETTING_DEFAULTS: NotificationSettings = {
  transactionEmail: true,
  productEmail: true,
  marketingEmail: false,
  transactionSms: false,
  productSms: false,
  groupChat: true,
};

export const notificationSettingsRequest = notificationSettings.partial().strict();
export type NotificationSettingsRequest = z.infer<typeof notificationSettingsRequest>;
